import { useState } from "react";
import StepOne from "./components/step-one";
import StepTwo from "./components/step-two";
import Summary from "./components/summary";
import StepZero from "./components/step-zero";
import StepOneMeals from "./components/step-one-meals";

const steps = ["scanning", "total", "guests", "meals", "summary"];

export default function App() {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    total: "",
    sst: "",
    guests: [""],
    splitMode: "even",
    value: [],
    scanned: false,
    wantScan: null,
    imageSelected: false,
  });

  const next = () => setStep((prev) => Math.min(prev + 1, steps.length - 1));
  const back = () => setStep((prev) => Math.max(prev - 1, 0));

  return (
    <div style={styles.pageWrapper}>
      {/* Top Navigation Bar */}
      <nav style={styles.navbar}>
        <div style={styles.navContent}>
          <div style={styles.brand}>
            <img src="/logo.png" alt="Logo" style={styles.logo} />
            <span style={styles.title}>BillSplit</span>
          </div>
          {/* <div style={styles.navLinks}>
            <a href="#what" style={styles.link}>
              What I Do
            </a>
            <a href="#contact" style={styles.link}>
              Contact
            </a>
          </div> */}
        </div>
      </nav>

      {/* Intro Section */}
      {/* <div id="about" style={styles.intro}>
        <h1 style={styles.introTitle}>Apps that Solve Real Problems</h1>
        <p style={styles.introDesc}>
          Discover a collection of apps I've built—designed for usability,
          performance, and purpose. From personal productivity to legal tech,
          there's something for everyone.
        </p>
      </div> */}

      {/* Step Form Card */}
      <div style={styles.wrapper} id="start">
        <div style={styles.box}>
          {step === 0 && (
            <StepZero
              data={formData}
              setData={setFormData}
              onNext={() => setStep(1)}
            />
          )}
          {step === 1 && <StepOne data={formData} setData={setFormData} />}
          {step === 2 && <StepTwo data={formData} setData={setFormData} />}
          {step === 3 && <StepOneMeals data={formData} setData={setFormData} />}
          {step === 4 && <Summary data={formData} setData={setFormData} />}

          {/* Navigation buttons */}
          <div style={styles.buttons}>
            {step > 0 && (
              <button onClick={back} style={scanBtn}>
                Back
              </button>
            )}
            {step > 0 && step < 5 && (
              <button onClick={next} style={scanBtn}>
                Next
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pageWrapper: {
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#ffffff",
    minHeight: "100vh",
  },
  navbar: {
    backgroundColor: "#ffffff",
    padding: "1rem 2rem",
    // borderBottom: "1px solid #eaeaea",
    position: "sticky",
    top: 0,
    zIndex: 1000,
  },
  navContent: {
    maxWidth: "1024px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  brand: {
    display: "flex",
    alignItems: "center",
  },
  logo: {
    height: "28px",
    marginRight: "8px",
  },
  title: {
    fontWeight: "bold",
    fontSize: "18px",
    color: "#1E3A8A",
  },
  navLinks: {
    display: "flex",
    gap: "1.5rem",
  },
  link: {
    textDecoration: "none",
    color: "#1E3A8A",
    fontSize: "16px",
  },
  intro: {
    maxWidth: "800px",
    margin: "2rem auto 1rem auto",
    padding: "0 1.5rem",
    textAlign: "center",
  },
  introTitle: {
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "0.5rem",
    color: "#111827",
  },
  introDesc: {
    fontSize: "16px",
    color: "#4B5563",
    lineHeight: "1.5",
  },
  wrapper: {
    display: "flex",
    justifyContent: "center",
    padding: "2rem 1rem",
  },
  box: {
    background: "#fff",
    padding: "2rem",
    borderRadius: "20px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: "600px",
    boxSizing: "border-box",
  },
  buttons: {
    marginTop: "1.5rem",
    display: "flex",
    justifyContent: "space-between",
  },
};

const scanBtn = {
  padding: "0.5rem 1.25rem",
  backgroundColor: "#4a90e2",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: "500",
  cursor: "pointer",
};
